import React, { useState } from "react";
import Blind_Sample_From from "./blind_Sample_Form/Blind_Sample_From";
import Blind_Sample_table from "./blind_Sample_table/Blind_Sample_table";
import { FixIDS } from "../../../../../../../utils/fixIDS";
import { useSelector } from "react-redux";

function Blind_Sample({
  validitydetails,
  setCurrentPage,
  currentPage,
  openDeleteModal,
}) {
  const [showTable, setShowTable] = useState(false);

  const permissions = useSelector((state) => state.auth.permissions);

  const haveReadPermission = permissions?.includes(FixIDS.ensuring_the_validity.List);
  const haveAddPermission = permissions?.includes(FixIDS.blind_sample.Add); //form


  return (
    <>
      <div className="imperiality_Form_div">
        {haveAddPermission && <Blind_Sample_From
          validityTypeId={5}
          onProceed={() => setShowTable(true)}
        />}
      </div>

      {/* {showTable && ( */}
      <div className="imperiality_table_div">
        {haveReadPermission && <Blind_Sample_table
          openDeleteModal={openDeleteModal}
          validitydetails={validitydetails}
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
          validityTypeId={5}
        />}
      </div>
      {/* )} */}
    </>
  );
}

export default Blind_Sample;
